import { onMessageFromWebApp, sendMessageToWebApp } from "./webAppMessenger";
import fromEntries from "fromentries";
import { APP_LOADED, DEVICE_DETAIL } from "./messageTypes";

onMessageFromWebApp(APP_LOADED, async () => {
  console.log("onMessageFromWebApp", APP_LOADED);
  const localStorageState = fromEntries(Object.entries(window.localStorage));
  const messageContents = {
    device: {
      ...window.device
    },
    build: {
      ...window.BuildInfo
    },
    localStorageState,
    appOrigin: window.location.origin
  };
  if (window.biometricAuthentication) {
    messageContents.biometricAuthentication = {
      isAvailable: window.biometricAuthentication.isAvailable,
      hasCredentialsStoredInKeychain: await window.biometricAuthentication.hasCredentialsStoredInKeychain()
    };
  }
  if (window.visualViewport) {
    const { height, width } = window.visualViewport;
    messageContents.visualViewport = { height, width };
  }
  sendMessageToWebApp(DEVICE_DETAIL, messageContents);
});
